import { CommonModule } from '@angular/common';
import { Component, OnInit, inject, output } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { PAYMENTS_CONFIG } from '../../payments.config';
import { PersonalInfo } from '../../models/payment.models';
import { ZimbabweNationalIdFormatterDirective } from '../../directives/nin-format.directive';

/** Guest checkout: captures personal information and links to sign in / up. */
@Component({
  selector: 'lib-payment-auth',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    ZimbabweNationalIdFormatterDirective,
  ],
  templateUrl: './auth.html',
})
export class Auth implements OnInit {
  readonly personalInfo = output<PersonalInfo>();

  private readonly config = inject(PAYMENTS_CONFIG);
  private readonly fb = inject(FormBuilder);

  authInfo = this.config.checkoutAuthInfo ?? {};

  personalInfoFormGroup: FormGroup = this.fb.group({
    firstname: ['', [Validators.required]],
    lastname: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phoneNumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    identificationNumber: ['', [Validators.required, this.zimbabweNationalIdValidator]],
  });

  ngOnInit(): void {
    this.personalInfoFormGroup.valueChanges.subscribe(() => {
      if (this.personalInfoFormGroup.valid) {
        this.personalInfo.emit(this.personalInfoFormGroup.value);
      }
    });
  }

  zimbabweNationalIdValidator(control: AbstractControl): ValidationErrors | null {
    const idPattern = /^(\d{2}-\d{6,7}[A-Z]\d{2})$/;
    if (control.value && !idPattern.test(control.value)) {
      return { invalidNationalId: true };
    }
    return null;
  }

  loginWithGoogle(): void {
    if (this.authInfo.googleSignUrl) {
      window.location.href = this.authInfo.googleSignUrl;
    }
  }
}
